import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'

import Box from '@mui/material/Box';
import SimpleNotificationService from './notifications/NotificationService';
import Notifications from './notifications/Notifications';
import { WhoAmIEvent, WhoAmIResult } from 'bloggers-backend/lib/users/domain';
import { CircularProgress } from '@mui/material';

import { LicenseInfo } from '@mui/x-license';
import { LoggedOutView } from './views/LoggedOutView';
import { client } from './AppContext';
import { AdminView } from './views/AdminView';
import { ManagerView } from './views/ManagerView';
import { CreatorView } from './views/CreatorView';
import { AppContext, signOut } from './AppContext';

// https://mui.com/x/introduction/licensing/#license-key-security
LicenseInfo.setLicenseKey('a3d73c4a3a323f979a7cce381be5f2bcTz0xMzAzNTIsRT0xODEzNDQ5NTk5MDAwLFM9cHJvLExNPXBlcnBldHVhbCxQVj1RMS0yMDI2LFE9MSxBVD1zaW5nbGUsS1Y9Mg==');

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <Box sx={{width: '100vw', height: '100vh',display: 'flex', alignItems: "center"}}>
    <CircularProgress sx={{margin: "0 auto"}}/>
  </Box>
);

(async () => {
  const queryClient = new QueryClient()
  
  const whoAmI = await client<WhoAmIEvent, WhoAmIResult>({
    event: 'whoAmI',
    data: null
  });

  if (whoAmI.success) {
    const user = whoAmI.value;

    root.render(
      <React.StrictMode>
        <Router>
          < AppContext.Provider value={{
              notificationsService: new SimpleNotificationService(),
              client,
              user,
              signOut
          }}>
            <QueryClientProvider client={queryClient}>
              <Box sx={{ height: '100vh', display: 'flex', flexDirection: 'column' }}>
                {
                  (() => {
                    if (user.role === "admin") {
                      return <AdminView/>;
                    } else if (user.role === "manager") {
                      return  <ManagerView/>;
                    } else if (user.role === "creator") {
                      return <CreatorView/>;
                    }
                  })()
                }
              </Box>
              <Notifications/>
            </QueryClientProvider>
          </AppContext.Provider>
        </Router>
      </React.StrictMode>
    );
  } else {
    root.render(<LoggedOutView/>)
  }
})();
